var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useIcon } from '@shapeable/icons';
import { Icon } from './icon';
var cls = classNames('content-with-icon-embed');
export var ContentWithIconEmbedDefaultProps = {
  size: 48,
  color: 'strong'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    align-items: center;\n    list-style: none !important;\n    \n    margin-bottom: 2em;\n\n    &::before {\n      content: none !important;\n      padding-left: 0;\n    }\n  "], ["\n    display: inline-flex;\n    align-items: center;\n    list-style: none !important;\n    \n    margin-bottom: 2em;\n\n    &::before {\n      content: none !important;\n      padding-left: 0;\n    }\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-right: ", ";\n    flex-shrink: 0;\n  "], ["\n    margin-right: ", ";\n    flex-shrink: 0;\n  "])), theme.UNIT(3))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.li(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Content: styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var ContentWithIconEmbed = function (props) {
  var className = props.className,
    children = props.children,
    size = props.size,
    color = props.color,
    name = props.name,
    slug = props.slug;
  var Icon = useIcon(name);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, Icon && React.createElement(My.Icon, {
    size: size,
    color: color
  }, " ", React.createElement(Icon, null), " "), React.createElement(My.Content, null, children));
};
ContentWithIconEmbed.defaultProps = ContentWithIconEmbedDefaultProps;
ContentWithIconEmbed.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;